<footer class="footer-shell" role="contentinfo">
  <div class="footer-inner">
    <div class="footer-logo">
      <span class="footer-logo-link" title="CenterPoint Energy">
        <img
          class="footer-logo-image"
          alt="CenterPoint Energy Logo - white"
          src="https://edge.sitecorecloud.io/centerpointd332-cnpdigital9938-prod15ff-c206/media/project/centerpoint/shared/centerpointenergy-logo-white.svg?iar=0"
        />
      </span>
    </div>

    <div class="footer-content">
      <div class="footer-social-links" aria-label="Social media links">
        <a
          href="https://www.facebook.com/CenterPointEnergy"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="CNP Facebook"
          class="footer-social-link"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M9.198 21.5h4v-8.01h3.604l.396-3.98h-4V7.5a1 1 0 0 1 1-1h3v-4h-3a5 5 0 0 0-5 5v2.01h-2l-.396 3.98h2.396v8.01Z"
            ></path>
          </svg>
        </a>
        <a
          href="https://x.com/centerpoint"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="CNP Twitter"
          class="footer-social-link"
        >
          <svg
            viewBox="0 0 640 640"
            fill="currentColor"
            aria-hidden="true"
            width="24"
            height="24"
          >
            <path
              d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"
            ></path>
          </svg>
        </a>
        <a
          href="https://www.youtube.com/user/centerpointenergyvid"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="CNP Youtube"
          class="footer-social-link"
        >
          <svg
            viewBox="0 0 640 640"
            fill="currentColor"
            width="24"
            height="24"
            aria-hidden="true"
          >
            <path
              d="M581.7 188.1C575.5 164.4 556.9 145.8 533.4 139.5C490.9 128 320.1 128 320.1 128C320.1 128 149.3 128 106.7 139.5C83.2 145.8 64.7 164.4 58.4 188.1C47 231 47 320.4 47 320.4C47 320.4 47 409.8 58.4 452.7C64.7 476.3 83.2 494.2 106.7 500.5C149.3 512 320.1 512 320.1 512C320.1 512 490.9 512 533.5 500.5C557 494.2 575.5 476.3 581.8 452.7C593.2 409.8 593.2 320.4 593.2 320.4C593.2 320.4 593.2 231 581.8 188.1zM264.2 401.6L264.2 239.2L406.9 320.4L264.2 401.6z"
            ></path>
          </svg>
        </a>
      </div>

      <div class="footer-nav">
        <a
          href="https://www.centerpointenergy.com/en-us/corporate/legal/privacy-policy"
          target="_blank"
          class="footer-link"
          >Privacy</a
        >
        <span aria-hidden="true">•</span>
        <a
          href="https://www.centerpointenergy.com/en-us/corporate/legal/terms-of-use"
          target="_blank"
          class="footer-link"
          >Terms &amp; Conditions</a
        >
        @if (showConsent) {
          <span aria-hidden="true">•</span>
        }
        @if (showConsent) {
          <span id="teconsent" class="trustarc-consent-link"></span>
        }
        <span>|</span>
        <span>Copyright © 2026 CenterPoint Energy</span>
      </div>
    </div>
  </div>
</footer>
